export default __webpack_public_path__ + "static/ak-cached/24h/media/steps-tip-suspended-after.bcd38aee.svg";